// API Client
import EpdServiceClient, { get, delete_, put } from "../../api/EpdServiceClient";
import { Material } from "@/types/Views/MaterialDatabase/Material";
import { NewMaterial } from "@/types/Views/CreateMaterial/NewMaterial";
import { GetMaterialQuery } from "@/graphql";
import CarbonClient from "@/api/CarbonClient";

import type { Tag } from "@/stores/project/types/enum";

// API Path
const path = "api/material/";
const pathV2 = "api/material/v2/";

async function getMaterialTenants() {
  const response = await get(`${path}search/tenants`);
  return response.tenants;
}

async function getMaterial(id: string): Promise<Material> {
  return get(`${path}${id}`);
}

async function deleteMaterial(id: string) {
  return delete_(`${path}${id}`);
}

async function updateMaterial(material: NewMaterial) {
  return put(`${path}${material.id}`, material);
}

async function getMaterialV2(id: string): Promise<GetMaterialQuery["material"]> {
  return get(`${pathV2}${id}`);
}

export { getMaterialTenants, getMaterial, deleteMaterial, updateMaterial, getMaterialV2 };

// todso
export async function getEpdTypeEnums() {
  const response = await EpdServiceClient.get("api/material/epdtypeenums");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

// todso
export async function getStageStateEnum() {
  const response = await EpdServiceClient.get("api/material/stagestateenum");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
// todso
export async function fetchStageStateEnum() {
  const response = await EpdServiceClient.get("api/material/stagestateenum");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getIndicatorTypeNames() {
  const response = await EpdServiceClient.get("api/material/indicatorTypeNames");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export const getBuildingProjectLookups = async () => {
  const response = await CarbonClient.get(`/api/enums/buildingprojectenums`);
  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status };
  }
};

export async function getLifeCycleStages() {
  const response = await EpdServiceClient.get("api/material/stagetypeenum");
  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getSpecificationForms() {
  const response = await EpdServiceClient.get("api/material/epdspecificationform");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getCanMapDictionaries() {
  const response = await CarbonClient.get("api/Mapping/CanMapDictionaries");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getProductTypes() {
  const response = await EpdServiceClient.get("api/material/epdproductindustrytype");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export const getTagsTypesForms = async (): Promise<Tag[] | { status: number; message?: string }> => {
  const response = await EpdServiceClient.get("api/material/TagsTypesForms");

  if (response.status === 200) {
    return response.data.tags as Tag[];
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
};

export async function getDataSources() {
  const response = await EpdServiceClient.get("api/DataSource");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getDeclaredUnits() {
  const response = await EpdServiceClient.get("api/material/declaredunitenum");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getMassUnits() {
  const response = await EpdServiceClient.get("api/material/declaredmassunitenum");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getIndicatorTypes() {
  const response = await EpdServiceClient.get("api/material/indicatorenums");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
